<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-text
        class="pt-4"
        style="position: relative;"
      >
        <div class="pl-3">
          <h3 class="display-1 font-weight-light orange--text mb-2">Cadastre um novo posto</h3>
          <div class="font-weight-light title mb-2">
          </div>
        </div>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              md4
            >
              <v-text-field
                label="Nome fantásia"
                v-model="posto_model.nome_fantasia"
                required
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm8
            >
              <v-text-field
                :rules="razaoRules"
                label="Razão Social"
                v-model="posto_model.razao_social"
                hint="Insira o nome oficial do CNPJ"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="posto_model.cnpj"
                :rules="[ () => validarMatematicamenteCNPJ() || 'Esse Cpf não é valido']"
                label="Cnpj"
                mask="##.###.###/####-##"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                @keyup="searchCep()"
                v-model="posto_model.cep"
                maxlength="8"
                label="Cep"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="posto_model.logradouro"
                label="Logradouro"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                v-model="posto_model.numero"
                label="Nº"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="posto_model.complemento"
                label="Complemento"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="posto_model.bairro"
                label="Bairro"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="posto_model.cidade"
                label="Cidade"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                v-model="posto_model.uf"
                label="UF"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
          flat
          color="primary"
          @click="fechar()"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          flat
          color="primary"
          @click="salvarPosto"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  data () {
    return {
      valid: true,
      posto_model: {
        checkbox: false,
        razao_social: '',
        cnpj: '',
        nome_fantasia: '',
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        contato1: '',
        contato2: '',
        contato3: '',
        rep_nome: '',
        rep_sobrenome: '',
        rep_cpf: '',
        rep_contato: '',
        email: '',
        latitude: null,
        longitude: null
      },
      razaoRules: [
        v => !!v || 'Insira Razão Social!'
      ],
      cnpjRules: [
        v => !!v || 'Insira Cnpj!'
      ]
    }
  },
  methods: {
    validarMatematicamenteCNPJ () {
      if (this.posto_model.cnpj.length === 14) {
        var digito1 = null
        var digito2 = null
        var indiceDeCalculo = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        digito1 = this.calculoDv(indiceDeCalculo, 2)
        indiceDeCalculo = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        digito2 = this.calculoDv(indiceDeCalculo, 1)
        if (digito1 > 9) {
          if (parseInt(this.posto_model.cnpj.substring(12, 13)) === 0 && digito2 === parseInt(this.posto_model.cnpj.substring(13))) {
            return true
          }
        } else {
          if (digito1 === parseInt(this.posto_model.cnpj.substring(12, 13)) || digito2 === parseInt(this.posto_model.cnpj.substring(13))) {
            return true
          }
        }
      }
    },
    calculoDv (indiceDeCalculo, dig) {
      var somaCnpj = 0
      var i = 0
      while (i < this.posto_model.cnpj.length - dig) {
        somaCnpj = somaCnpj + this.posto_model.cnpj.substring(i, i + 1) * indiceDeCalculo[i]
        i++
      }
      return (somaCnpj * 10) % 11
    },
    fechar () {
      this.$refs.form.reset()
      this.$emit('fechar')
    },
    searchCep () {
      fetch(`https://viacep.com.br/ws/${this.posto_model.cep}/json/`,
        {
          method: 'get',
          mode: 'cors',
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(res => res.json())
        .then(json => {
          this.posto_model.logradouro = json.logradouro
          this.posto_model.bairro = json.bairro
          this.posto_model.cidade = json.localidade
          this.posto_model.uf = json.uf
        })
    },
    async salvarPosto () {
      if (this.$refs.form.validate()) {
        try {
          await this.buscarCoordenadas()
        } catch {
          this.$emit('error', 'Não foi possível pegar coordenadas geograficas do posto! Verifique seu endereço e tente novamente.')
        }
        await this.$store.dispatch('cadastroPostoByClient', { posto: this.posto_model }).then(() => {
          this.$emit('success', 'Posto Cadastrado com sucesso')
          this.$emit('carregar')
          this.$emit('fechar')
        }).catch(() => {
          this.$emit('error', 'Não foi possível cadastrar posto! Verifique as informações e tente novamente.')
        })
      }
    },
    buscarCoordenadas () {
      return this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.posto_model.logradouro,
        numero: this.posto_model.numero,
        bairro: this.posto_model.bairro,
        cidade: this.posto_model.cidade,
        estado: this.posto_model.uf
      })
        .then(json => {
          this.posto_model.latitude = json.latitude
          this.posto_model.longitude = json.longitude
        })
    }
  }
}
</script>
